import React from 'react';

export const orderReturnNoSealConfig = [
  {
    path: '/input-seal-no',
    component: React.lazy(() => import('./listing/listing')),
  },

  {
    path: '/input-seal-no/add',
    component: React.lazy(() => import('./add/detail')),
  },

  {
    path: '/input-seal-no/overview',
    component: React.lazy(() => import('./overview/detail')),
  },

  // {
  //   path: '/assign-pic/rincian-order-cash-return-assign',
  //   component: React.lazy(() =>
  //     import('./rincianOrderAssign/rincianOrderAssign'),
  //   ),
  // },
];
